export default {
      id: "pushpay-logo-sidebar-usage",
      viewBox: "0 0 72 72",
      url: __webpack_public_path__ + "svg-sprite-defs.svg#pushpay-logo-sidebar",
      toString: function () {
        return this.url;
      }
    }